import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[16],
	},
	containerSmall: {
		width: '100%',
	},
	fill: {
		borderRadius: THEME.common.borderRadiusPill,
		height: 12,
		transition: 'width 0.3s',
	},
	fillGreen: {
		backgroundColor: THEME.colors.success.main,
	},
	fillRed: {
		backgroundColor: THEME.colors.danger.main,
	},
	fillSmall: {
		height: 8,
	},
	fillYellow: {
		backgroundColor: THEME.colors.warning.main,
	},
	goal: {
		color: THEME.colors.text.light,
		fontWeight: fontWeights.standard,
	},
	marker: {
		backgroundColor: THEME.colors.text.main,
		height: 20,
		position: 'absolute',
		top: -4,
		transition: 'left 0.3s',
		width: 2,
	},
	track: {
		backgroundColor: THEME.colors.border.light,
		borderRadius: THEME.common.borderRadiusPill,
		height: 12,
		position: 'relative',
		width: 240,
	},
	trackSmall: {
		height: 8,
		width: '100%',
	},
	values: {
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.lg,
		fontWeight: fontWeights.bold,
		whiteSpace: 'nowrap',
	},
});
